import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../ui/Icon';
import { useAuth } from '../contexts/AuthContext';
import { supabaseEnabled } from '../config/supabase';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signInAdmin, session } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const from = (location.state as any)?.from?.pathname || '/';

  useEffect(() => {
    if (session) navigate(from, { replace: true });
  }, [session, from, navigate]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!supabaseEnabled) {
      setError('Supabase Auth nie skonfigurowane (REACT_APP_SUPABASE_URL)');
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      await signInAdmin(email.trim(), password);
    } catch (err: any) {
      setError(err?.message || 'Logowanie nieudane');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="alogin" data-theme="light">
      <div className="alogin-card">
        <div className="logo"><Icon name="package-check" size={26} /></div>
        <h1>PackFlow</h1>
        <div className="sub">Panel administracyjny · Insolitum Universe</div>

        {!supabaseEnabled && (
          <div className="pill pill-warn" style={{ height: 'auto', padding: '9px 12px', borderRadius: 10, width: '100%', marginBottom: 14 }}>
            <Icon name="alert-triangle" size={14} /> Supabase Auth nieaktywne — ustaw REACT_APP_SUPABASE_URL i ANON_KEY.
          </div>
        )}
        {error && (
          <div className="pill pill-err" style={{ height: 'auto', padding: '9px 12px', borderRadius: 10, width: '100%', marginBottom: 14 }}>
            <Icon name="alert-circle" size={14} /> {error}
          </div>
        )}

        <form onSubmit={onSubmit}>
          <div className="wfield">
            <label>E-mail</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus disabled={submitting || !supabaseEnabled} placeholder="admin@firma.pl" />
          </div>
          <div className="wfield">
            <label>Hasło</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={submitting || !supabaseEnabled} placeholder="••••••••" />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', minHeight: 44, marginTop: 6 }}
            disabled={submitting || !supabaseEnabled || !email || !password}>
            {submitting ? 'Logowanie…' : <><Icon name="log-in" size={16} /> Zaloguj</>}
          </button>
        </form>

        <div className="muted" style={{ fontSize: 12, marginTop: 18, textAlign: 'center' }}>
          Stacja robocza? <a href="/packing-station/login" style={{ color: 'var(--accent-text)', fontWeight: 600 }}>Logowanie PIN-em</a>
        </div>
      </div>
    </div>
  );
}
